import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { GenericComponentsModule } from '@helios/generic-components'
import {
  NgbAccordionModule,
  NgbModalModule,
  NgbNavModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap'
import { TableLayoutModule } from '@northfork/ag-grid-angular'
import { NfFormsModule } from '@northfork/ng-basics'
import { ClearwaterTransactionDetailGridComponent } from './clearwater-transaction-detail-grid/clearwater-transaction-detail-grid.component'
import { TpiModalComponent } from './component/tpi-modal/tpi-modal.component'
import { ExternalTransactionDetailGridComponent } from './external-transaction-detail-grid/external-transaction-detail-grid.component'
import { TransactionDetailPanelComponent } from './transaction-detail-panel.component'

@NgModule({
  imports: [
    CommonModule,
    TableLayoutModule,
    GenericComponentsModule,
    NgbModalModule,
    NgbTooltipModule,
    NgbNavModule,
    NfFormsModule,
    NgbAccordionModule,
  ],
  declarations: [
    TransactionDetailPanelComponent,
    TpiModalComponent,
    ExternalTransactionDetailGridComponent,
    ClearwaterTransactionDetailGridComponent,
  ],
  exports: [TransactionDetailPanelComponent, TpiModalComponent],
})
export class TransactionDetailModule {}

export { TransactionDetailPanelComponent }
